module.exports = __webpack_public_path__ + "static/media/columns.39392e41.ico";